/* eslint-disable */ import { assertBoolean, assertNumber, attributeSelectionComponent, attributeSwitchComponent, composedOfComponent, dimensionIndicatorComponent, distanceDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { StrikePlateBendType, StrikePlateShapeType, StrikeTonguePosition } from '../model/index.js';
export const strikePlateComponents = [
    attachComponent.withComponent(composedOfComponent, '$tongueBend', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.$tongueBend?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(distanceDimensionComponent, 'horizontalLength', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.horizontalLength,
            self.$minHorizontalLength,
            self.$maxHorizontalLength
        ], (horizontalLength, $minHorizontalLength, $maxHorizontalLength)=>({
            value: horizontalLength,
            min: $minHorizontalLength,
            max: $maxHorizontalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'tStrikeMainWidth', true).withEntity('StrikePlate').withFilter((self)=>({
            active: self.$isTStrikeFilter
        })).attach(memoEval((self)=>[
            self.$tStrikeMainWidth,
            self.$minTStrikeMainWidth,
            self.$maxTStrikeMainWidth
        ], ($tStrikeMainWidth, $minTStrikeMainWidth, $maxTStrikeMainWidth)=>({
            value: $tStrikeMainWidth,
            min: $minTStrikeMainWidth,
            max: $maxTStrikeMainWidth
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'verticalLength', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.verticalLength,
            self.$minLength,
            self.$maxVerticalLength
        ], (verticalLength, $minLength, $maxVerticalLength)=>({
            value: verticalLength,
            min: $minLength,
            max: $maxVerticalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            verticalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'mainCornerRadius', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.mainCornerRadius,
            self.$maxMainCornerRadius
        ], (mainCornerRadius, $maxMainCornerRadius)=>({
            value: mainCornerRadius,
            min: 0.5,
            max: $maxMainCornerRadius
        })), (state)=>{
        assertNumber(state.value);
        return {
            mainCornerRadius: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'tongueHorizontalLength', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.tongueHorizontalLength,
            self.$minTongueHorizontalLength,
            self.$maxTongueHorizontalLength
        ], (tongueHorizontalLength, $minTongueHorizontalLength, $maxTongueHorizontalLength)=>({
            value: tongueHorizontalLength,
            min: $minTongueHorizontalLength,
            max: $maxTongueHorizontalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            tongueHorizontalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'tongueOffsetStart', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.tongueOffsetStart,
            self.$minTongueOffset,
            self.$maxTongueOffsetStart
        ], (tongueOffsetStart, $minTongueOffset, $maxTongueOffsetStart)=>({
            value: tongueOffsetStart,
            min: $minTongueOffset,
            max: $maxTongueOffsetStart
        })), (state)=>{
        assertNumber(state.value);
        return {
            tongueOffsetStart: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'tongueOffsetEnd', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.tongueOffsetEnd,
            self.$minTongueOffset,
            self.$maxTongueOffsetEnd
        ], (tongueOffsetEnd, $minTongueOffset, $maxTongueOffsetEnd)=>({
            value: tongueOffsetEnd,
            min: $minTongueOffset,
            max: $maxTongueOffsetEnd
        })), (state)=>{
        assertNumber(state.value);
        return {
            tongueOffsetEnd: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'tongueCornerRadius', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.tongueCornerRadius,
            self.$maxTongueCornerRadius
        ], (tongueCornerRadius, $maxTongueCornerRadius)=>({
            value: tongueCornerRadius,
            min: 0.5,
            max: $maxTongueCornerRadius
        })), (state)=>{
        assertNumber(state.value);
        return {
            tongueCornerRadius: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'jointCornerRadius', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.jointCornerRadius,
            self.$maxJointCornerRadius
        ], (jointCornerRadius, $maxJointCornerRadius)=>({
            value: jointCornerRadius,
            min: 0,
            max: $maxJointCornerRadius
        })), (state)=>{
        assertNumber(state.value);
        return {
            jointCornerRadius: state.value
        };
    }),
    attachComponent.withComponent(dimensionIndicatorComponent, 'tongueOffsetStart', true).withEntity('StrikePlate').withFilter((self)=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ],
            active: self.$isTStrikeFilter
        })).attach(memoEval((self)=>[
            self.$tongueIndicatorBottomY,
            self.$middleZ,
            self.$tongueIndicatorExtrusionX,
            self.$indicatorLabelFontSize
        ], ($tongueIndicatorBottomY, $middleZ, $tongueIndicatorExtrusionX, $indicatorLabelFontSize)=>({
            startX: 0,
            endX: 0,
            startY: 0,
            endY: $tongueIndicatorBottomY,
            startZ: $middleZ,
            endZ: $middleZ,
            extrusionX: $tongueIndicatorExtrusionX,
            extrusionY: 0,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize,
            labelAngle: 1.5708
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'tongueHeight', true).withEntity('StrikePlate').withFilter((self)=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ],
            active: self.$isTStrikeFilter
        })).attach(memoEval((self)=>[
            self.$tongueIndicatorBottomY,
            self.$tongueIndicatorTopY,
            self.$middleZ,
            self.$tongueIndicatorExtrusionX,
            self.$indicatorLabelFontSize
        ], ($tongueIndicatorBottomY, $tongueIndicatorTopY, $middleZ, $tongueIndicatorExtrusionX, $indicatorLabelFontSize)=>({
            startX: 0,
            endX: 0,
            startY: $tongueIndicatorBottomY,
            endY: $tongueIndicatorTopY,
            startZ: $middleZ,
            endZ: $middleZ,
            extrusionX: $tongueIndicatorExtrusionX,
            extrusionY: 0,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize,
            labelAngle: 1.5708
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'tongueOffsetEnd', true).withEntity('StrikePlate').withFilter((self)=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ],
            active: self.$isTStrikeFilter
        })).attach(memoEval((self)=>[
            self.$tongueIndicatorTopY,
            self.$sizeY,
            self.$middleZ,
            self.$tongueIndicatorExtrusionX,
            self.$indicatorLabelFontSize
        ], ($tongueIndicatorTopY, $sizeY, $middleZ, $tongueIndicatorExtrusionX, $indicatorLabelFontSize)=>({
            startX: 0,
            endX: 0,
            startY: $tongueIndicatorTopY,
            endY: $sizeY,
            startZ: $middleZ,
            endZ: $middleZ,
            extrusionX: $tongueIndicatorExtrusionX,
            extrusionY: 0,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize,
            labelAngle: 1.5708
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'mainWidth', true).withEntity('StrikePlate').withFilter(()=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ]
        })).attach(memoEval((self)=>[
            self.$mainIndicatorStartX,
            self.$middleZ,
            self.$mainIndicatorEndX,
            self.$mainIndicatorExtrusion,
            self.$indicatorLabelFontSize
        ], ($mainIndicatorStartX, $middleZ, $mainIndicatorEndX, $mainIndicatorExtrusion, $indicatorLabelFontSize)=>({
            startX: $mainIndicatorStartX,
            startY: 0,
            startZ: $middleZ,
            endX: $mainIndicatorEndX,
            endY: 0,
            endZ: $middleZ,
            extrusionX: 0,
            extrusionY: $mainIndicatorExtrusion,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'tStrikeMainPlusTongueWidth', true).withEntity('StrikePlate').withFilter((self)=>({
            navigationStates: [
                'Dimensions',
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization',
                'FinalizationThumbnail'
            ],
            toolStates: [
                'Configure'
            ],
            active: self.hasBend
        })).attach(memoEval((self)=>[
            self.$tStrikeMainPlusTongueIndicatorStartX,
            self.$middleZ,
            self.$tStrikeMainPlusTongueIndicatorEndX,
            self.$tStrikeMainPlusTongueIndicatorExtrusion,
            self.$indicatorLabelFontSize
        ], ($tStrikeMainPlusTongueIndicatorStartX, $middleZ, $tStrikeMainPlusTongueIndicatorEndX, $tStrikeMainPlusTongueIndicatorExtrusion, $indicatorLabelFontSize)=>({
            startX: $tStrikeMainPlusTongueIndicatorStartX,
            startY: 0,
            startZ: $middleZ,
            endX: $tStrikeMainPlusTongueIndicatorEndX,
            endY: 0,
            endZ: $middleZ,
            extrusionX: 0,
            extrusionY: $tStrikeMainPlusTongueIndicatorExtrusion,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'bendType', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.bendType
        ], (bendType)=>({
            value: bendType,
            options: [
                {
                    label: '6.5mm',
                    description: 'Universal 6.5mm internal radius bend for various strikes, if selecting for longreach use 1.5mm thick only',
                    value: 'ir5'
                },
                {
                    label: '11mm',
                    description: 'Universal 11mm internal radius bend for various strikes',
                    value: 'ir11'
                }
            ]
        })), (state)=>{
        StrikePlateBendType.assert(state.value);
        return {
            bendType: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'tonguePosition', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.tonguePosition
        ], (tonguePosition)=>({
            value: tonguePosition,
            options: [
                {
                    label: 'Left',
                    value: 'left'
                },
                {
                    label: 'Right',
                    value: 'right'
                }
            ]
        })), (state)=>{
        StrikeTonguePosition.assert(state.value);
        return {
            tonguePosition: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'shapeType', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.shapeType
        ], (shapeType)=>({
            value: shapeType,
            options: [
                {
                    label: 'T-Strike',
                    value: 'TStrike'
                },
                {
                    label: 'D-Strike',
                    value: 'DStrike'
                }
            ]
        })), (state)=>{
        StrikePlateShapeType.assert(state.value);
        return {
            shapeType: state.value
        };
    }),
    attachComponent.withComponent(attributeSwitchComponent, 'hasBend', true).withEntity('StrikePlate').attach(memoEval((self)=>[
            self.hasBend
        ], (hasBend)=>({
            value: hasBend
        })), (state)=>{
        assertBoolean(state.value);
        return {
            hasBend: state.value
        };
    })
];

//# sourceMappingURL=strike-plate.js.map